import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Enterprise, USER_ROLES } from '../../models/models';
import { ModalController } from '@ionic/angular';
import { DataService } from '../../services/data.service';
import { Errors } from '../../utils/errors';
import { Modal } from '../modal';
import { AuthService } from '../../services/auth.service';
import { ToastService } from '../../services/toast.service';
import { UserService } from '../../services/user.service';
import { filter, first } from 'rxjs';
import { SelectItemInterface } from 'src/app/components/select/select.component';

@Component({
  selector: 'app-user-create-modal',
  templateUrl: './user-create-modal.component.html',
  styleUrls: ['./user-create-modal.component.scss'],
})
export class UserCreateModalComponent extends Modal {
  @Input() save = false;
  userForm: FormGroup = new FormGroup({
    email: new FormControl(null, [Validators.required, Validators.email]),
    firstname: new FormControl(null, [Validators.required]),
    lastname: new FormControl(null, [Validators.required]),
    job: new FormControl(null, []),
    phone: new FormControl(null, []),
    mobile: new FormControl(null, []),
    role: new FormControl(null, [Validators.required]),
    enterpriseName: new FormControl(null, [Validators.required]),
    enterpriseId: new FormControl(null, [Validators.required]),
  });
  validating = false;
  rolesValues: SelectItemInterface[];
  enterprise: Enterprise;

  constructor(
    modalCtrl: ModalController,
    private dataService: DataService,
    private userService: UserService,
    public authService: AuthService,
    private toastService: ToastService
  ) {
    super(modalCtrl);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.dataService.selectedEnterprise
      .pipe(filter((enterprise) => !!enterprise))
      .pipe(first())
      .subscribe((enterprise) => {
        this.enterprise = enterprise;
        this.init();
      });
  }

  async init() {
    let rolesValues = Object.values(USER_ROLES).map((v) => ({
      label: v.label,
      value: v.value,
    }));
    // Only mutuelle users can add admin users; enterprise users cannot
    const currentUser = this.authService.user.value;
    if (currentUser.accessType !== 'mutuelle') {
      rolesValues = rolesValues.filter((v) => v.value !== 'admin');
    }
    this.rolesValues = rolesValues;
    this.userForm.get('role').setValue(this.rolesValues[0]?.value);
    this.userForm.get('enterpriseName').setValue(this.enterprise?.name);
    this.userForm.get('enterpriseId').setValue(this.enterprise?.id);
  }

  createUser() {
    if (!this.userForm.valid) {
      this.userForm.markAllAsTouched();
      return;
    }
    this.validating = true;
    const data = Object.assign({}, this.userForm.value);
    data['accessType'] = 'enterprise';
    data['enterpriseId'] = this.enterprise.id;

    // If save is false, close and return the user
    if (!this.save) {
      this.close({
        user: data,
      });
      return;
    }

    this.userService
      .createUser(data)
      .then((res) => {
        this.validating = false;
        this.close();
        this.toastService.open({
          header: 'Collaborateur ajouté !',
          message:
            'Votre collaborateur a bien été ajouté. Il va recevoir une confirmation par mail.',
          type: 'success',
        });
      })
      .catch((res) => {
        this.validating = false;
        this.toastService.open({
          header: 'Oops !',
          message: Errors.getError(res),
          type: 'error',
        });
      });
  }
}
